/* eslint-disable */

import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { Pages } from './Pages';
import { ReactElement, useContext } from 'react';
import { StoreProvider } from '../stores/StoreProvider';
import { StoreContext } from '../stores/storeContext';
import { AuthStore } from '../stores/application/AuthStore';
import { observer } from 'mobx-react';

export const PrivateRoute = observer(({ component: Component, ...rest }: any): ReactElement => {
	const storeProvider: StoreProvider = useContext(StoreContext);
	const authStore: AuthStore = storeProvider.authStore;

	if (authStore.hasAuthToken()) {
		return <Component {...rest} />;
	}

	return <Navigate to={Pages.REQUEST_LOGIN} replace />;
});
